export enum TextTag {
  P = 'p',
  SPAN = 'span',
  LI = 'li',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
}
